import React, { ComponentType, FocusEventHandler, useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFieldTooltip } from './tooltip';

export const withErrorTooltip =
  <P extends object & { name?: string; invalid?: boolean; onFocus?: FocusEventHandler }>(Component: ComponentType<P>) =>
  ({ onFocus, name, ...props }: P) => {
    const { getFieldState } = useFormContext();
    const { invalid, error } = name ? getFieldState(name) : { invalid: true, error: { message: 'Missed `name` prop' } };
    const [open, setOpen] = useState(invalid);

    const handleFocus: FocusEventHandler = useCallback(
      (e) => {
        setOpen(invalid);
        onFocus?.(e);
      },
      [onFocus, invalid],
    );

    return (
      <FormFieldTooltip colorSchema="error" message={error?.message} onClose={() => setOpen(false)} open={Boolean(open && error?.message)}>
        <div data-testid="withErrorTooltip" style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column' }}>
          <Component invalid={invalid} name={name} onFocus={handleFocus} {...(props as P)} />
        </div>
      </FormFieldTooltip>
    );
  };
